export default "__VITE_ASSET__C4t1A0Ro__"